import React, {type FC} from 'react'
import {Button, type ButtonProps} from 'uikit'
import {useAppDispatch, useAppSelector} from 'store'
import {getTranslates} from 'store/translates/selectors'
import {getRiddleDataThunk} from 'store/secretword/thunk'
import {refreshLetters} from 'store/letter/slice'
import type {CallbackType} from 'store/modal/entities'

export type StartGameMobileButtonProps = {
  onClick?: (callback: CallbackType) => void
  className?: string
  disabled?: boolean;
  size?: ButtonProps['size']
}

export const StartGameMobileButton: FC<StartGameMobileButtonProps> = (props) => {
  const {onClick, className, disabled = false, size = 'big'} = props

  const dispatch = useAppDispatch()
  const translates = useAppSelector(getTranslates)
  
  const handleStartGame = async () => {
    onClick?.(async () => {
      await dispatch(getRiddleDataThunk())
      dispatch(refreshLetters())
    })
  }

  return (
    <Button
      className={className}
      onClick={handleStartGame}
      size={size}
      otherProps={{disabled}}
    >
      {translates.NEW_GAME}
    </Button>
  )
}
